const conflictMarkers = {
    start: '<<<<<<<',
    end: '>>>>>>>',
};
export { conflictMarkers };
